import workspaceQuery from 'graphql/queries/supplier/PurchaseInvoiceWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/PurchaseInvoiceQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/PurchaseInvoiceDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/PurchaseInvoiceMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/supplier/SavePurchaseInvoiceTempMutation.graphql';
import aggregateQuery from 'graphql/queries/supplier/PurchaseInvoiceAggregateQuery.graphql';
import fragment from 'graphql/fragments/supplier/PurchaseInvoiceFragment.graphql';
import { purchaseInvoiceFormActionsForPermissions } from '../../../actions/supplier/PurchaseInvoiceAction';

function getFormUrl(rowData) {
  const { purchaseOrderMatching, documentStatus } = rowData;

  return documentStatus === 'DRAFT' && purchaseOrderMatching
    ? '/Suppliers/MatchPurchaseOrders/Details/'
    : '/Suppliers/Invoice/Details/';
}

const PurchaseInvoice = {
  type: 'PurchaseInvoice',
  title: 'Purchase Invoices',
  formTitle: 'Purchase Invoice',
  formUrl: '/Suppliers/Invoice/Details/',
  formUrlFromFunction: getFormUrl,
  workspaceUrl: '/Suppliers/Invoice/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'SUPPLIER_INVOICES',
  actions: [...purchaseInvoiceFormActionsForPermissions],
  dropdown: {
    query: workspaceQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
    remoteFilter: true,
  },
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED', 'CREDITED'],
    },
  ],
};

export default PurchaseInvoice;
